type ErrorResponse = {
    response?: {
        data?: unknown
    }
}

const getResponseData = (error: unknown) => (error as ErrorResponse | undefined)?.response?.data

const getNonEmptyString = (value: unknown) => (typeof value === 'string' && value.trim() ? value : undefined)

export const getApiErrorMessage = (error: unknown): string | undefined => {
    const responseData = getResponseData(error)
    if (!responseData || typeof responseData !== 'object') return undefined

    return getNonEmptyString((responseData as { message?: unknown }).message)
}

export const getErrorSearchTerms = (error: unknown): string[] => {
    const responseData = getResponseData(error)
    const terms = new Set<string>()
    const addTerm = (value: unknown) => {
        const term = getNonEmptyString(value)
        if (term) terms.add(term.trim().toLowerCase())
    }

    if (error instanceof Error) addTerm(error.message)
    if (typeof responseData === 'string') addTerm(responseData)
    if (responseData && typeof responseData === 'object') {
        addTerm((responseData as { message?: unknown }).message)
        addTerm((responseData as { code?: unknown }).code)
    }

    return Array.from(terms)
}
